import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useSelector } from "react-redux";
import { AddCircle } from "iconsax-react";
import CustomPagination from "../../Utils/CustomPagination";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";

function List(props) {
  const [batchList, setBatchList] = useState({ result: [], total: 0 });
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions,
  );
  const [batchNoFilter, setBatchNoFilter] = useState("");
  const [batchNo, setBatchNo] = useState("");
  const [productName, setProductName] = useState("");
  const [plantList, setPlantList] = useState([]);
  const [product, setProduct] = useState([]);

  const [plantName, setPlantName] = useState("");
  const [plantLocation, setPlantLocation] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [search, setSearch] = useState("");
  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };

  const columns = [
    {
      name: (
        <div>
          Batch No. <br />
        </div>
      ),
      selector: (row) => row.batch_no,
    },
    {
      name: (
        <div>
          Product Name <br />
        </div>
      ),
      selector: (row) => `${row.product_name} - (${row.productCode}) - ${row?.size}${row.unit?.toUpperCase() || ""}`.trim(),
      width:'290px'
    },
    {
      name: (
        <div>
          Plant Location/Code <br />
        </div>
      ),
      selector: (row) => row.plant_name,
    },
    {
      name: (
        <div>
          Batch Size <br />
        </div>
      ),
      selector: (row) => row.plant_batch_size,
    },
    {
      name: (
        <div>
          Date <br />
        </div>
      ),
      selector: (row) => moment(row.createdAt).format("DD-MM-YYYY hh:mm A"),
    },
    {
      name: (
        <div>
          Action <br />
        </div>
      ),
      center: true,
      cell: (row) => (
        <>
          {utils.hasPermission(
            primaryMenuRes,
            "Batch Release",
            "batch_release.create",
          ) && (
            <>
              {row?.status == "0" && (
                <RB.Button
                  className="btn btn-flat ms-1"
                  title="Add Production"
                  onClick={createProduction(row)}
                >
                  <AddCircle />
                </RB.Button>
              )}
            </>
          )}
        </>
      ),
    },
  ];

  useEffect(() => {
    getBatchList();
  }, [page]);

  const getBatchList = () => {
    setBatchList((prevState) => ({
      ...prevState,
      result: [],
    }));
    const fromDate = startDate ? moment(startDate).format("YYYY-MM-DD") : "";
    const toDate = endDate ? moment(endDate).format("YYYY-MM-DD") : "";
    let query = `page=${page}&per_page=${countPerPage}`;
    if (batchNo) query += `&batch_no=${batchNo}`;
    if (productName) query += `&product_id=${productName}`;
    // if (plantName) query += `&plant_name=${plantName}`;
    if (plantLocation) query += `&plant_id=${plantLocation}`;
    if (startDate) query += `&from_date=${fromDate}`;
    if (endDate) query += `&to_date=${fromDate}`;

    utils
      .callAPI("get", `production/batch/list?${query}`)
      .then((res) => {
        if (res && res.result) {
          setBatchList({
            result: res.result,
            total: res.total || 0,
          });
          setSearch("");
        } else {
          setBatchList({ result: [], total: 0 });
          setSearch("");
        }
      })
      .catch(() => {
        setBatchList({ result: [], total: 0 });
        setSearch("");
      });
  };

  useEffect(() => {
    getPlantList();
    getproduct();
  }, []);

  const getproduct = () => {
    utils
      .callAPI("get", `/Product/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setProduct(res?.result);
        } else {
          setProduct([]);
        }
      })
      .catch((err) => {
        setProduct([]);
      });
  };

  const getPlantList = () => {
    utils
      .callAPI("get", "/purchaseorder/plant/list")
      .then((res) => {
        if (typeof res !== "undefined") {
          setPlantList(res?.result);
        } else {
          setPlantList([]);
        }
      })
      .catch(() => {
        setPlantList([]);
      });
  };

  const createProduction = useCallback((row) => async () => {
    const propdata = {
      mode: "add",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleBatchNoFilterChange = (e) => {
    setBatchNoFilter(e.target.value);
    setPage(1);
  };

  const handleSearch = () => {
    setPage(1);
    setSearch("search");
  };

  const handleReset = () => {
    setBatchNo("");
    setProductName("");
    setPlantName("");
    setPlantLocation("");
    setDateRange([null, null]);
    setPage(1);

    setSearch("reset");
  };

  useEffect(() => {
    if (search == "search" || search == "reset") {
      getBatchList();
    }
  }, [search]);

  const productOptions = product.map((p) => ({
    value: p.id,
    label: p.productCode
      ? `${p.product_name} - (${p.productCode}) - ${p?.size} ${p?.unit?.toUpperCase() || ""}`
      : p.product_name,
  }));

  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow ">
          <RB.Card.Body>
            {utils.hasPermission(
              primaryMenuRes,
              "Batch Release",
              "batch_release.view",
            ) && (
              <>
                <RB.Row className="mb-3">
                  <RB.Col md={2} className="mt-2">
                    <RB.Form.Control
                      type="text"
                      placeholder="Batch No"
                      value={batchNo}
                      onChange={(e) => setBatchNo(e.target.value)}
                    />
                  </RB.Col>
                  <RB.Col md={3} className="mt-2">
                    <Select
                      options={productOptions}
                      value={
                        productName
                          ? productOptions.find(
                              (opt) => opt.value === productName,
                            )
                          : null
                      }
                      onChange={(selectedOption) =>
                        setProductName(
                          selectedOption ? selectedOption.value : null,
                        )
                      }
                      placeholder="Select Product Name"
                      isSearchable
                      isClearable
                    />
                  </RB.Col>

                  <RB.Col md={2} className="mt-2">
                    <RB.Form.Select
                      value={plantLocation}
                      onChange={(e) => setPlantLocation(e.target.value)}
                    >
                      <option value="">Plant Location</option>
                      {plantList.map((plant) => (
                        <option key={plant.id} value={plant.id}>
                          {plant.plant_name}
                        </option>
                      ))}
                    </RB.Form.Select>
                  </RB.Col>
                  <RB.Col md={3} className="mt-2">
                    <DatePicker
                      selectsRange
                      startDate={startDate}
                      endDate={endDate}
                      onChange={(update) => {
                        setDateRange(update);
                      }}
                      isClearable
                      placeholderText="Select Date Range"
                      className="form-control"
                      dateFormat="yyyy-MM-dd"
                    />
                  </RB.Col>

                  <RB.Col md="2" className="mt-2">
                    <RB.Button
                      variant="primary"
                      className="me-2"
                      onClick={handleSearch}
                    >
                      Search
                    </RB.Button>
                    <RB.Button variant="secondary" onClick={handleReset}>
                      Reset
                    </RB.Button>
                  </RB.Col>
                </RB.Row>
                <DataTable
                  columns={columns}
                  data={batchList.result || []}
                  highlightOnHover
                  responsive
                  striped
                  persistTableHead
                  keyField="id"
                  pagination
                  paginationServer
                  paginationTotalRows={batchList.total}
                  paginationPerPage={countPerPage}
                  paginationComponentOptions={{
                    noRowsPerPage: true,
                  }}
                  paginationComponent={() => (
                    <CustomPagination
                      currentPage={page}
                      totalRows={batchList.total}
                      rowsPerPage={countPerPage}
                      onPageChange={handlePageChange}
                    />
                  )}
                  onChangePage={(page) => setPage(page)}
                  customStyles={{
                    head: {
                      style: {
                        fontSize: "0.875rem",
                        fontWeight: "bold",
                      },
                    },
                  }}
                />
              </>
            )}
          </RB.Card.Body>
        </RB.Card>
      </div>
    </>
  );
}

export default List;
